import { api } from '../apiSlice';

const PROFILE_URL = '/profile';

export const profileApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProfile: build.query({
      query: () => ({
        url: `${PROFILE_URL}`,
        method: 'GET',
      }),
      providesTags: ['user'],
    }),
    changeProfilePassword: build.mutation({
      query: (data) => ({
        url: `${PROFILE_URL}/change-password`,
        method: 'PATCH',
        data: data,
      }),
      invalidatesTags: ['employee'],
    }),
  }),
});

export const { useGetProfileQuery, useChangeProfilePasswordMutation } =
  profileApi;
